export enum TOKEN_KEYS {
  AUTH_TOKEN_KEY = 'accessToken',
  REFRESH_TOKEN_KEY = 'refreshToken',
}
